import { api , base_url_v1 } from ".";

export const UpdateProfileApi = async (postData:any) => {
    const data = await api({ url: `${base_url_v1}update-profile` , method: "PATCH" , token:true , body:JSON.stringify(postData) })
    return { data };
}
